import { render } from "./ResetPassword.vue?vue&type=template&id=0212786f&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=0212786f&scoped=true&lang=css"

import exportComponent from "d:\\WinNMP\\WWW\\dapodik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212786f"]])

export default __exports__